import * as React from 'react'
import { Category, Action as analyticsAction } from '../../../util/analytics-data-attributes/analyticsAttributes'
import ModalAtom, { Sizes as ModalSizes } from '../../atoms/Modal/Modal'
import Styles, { Button } from './Modal.styles'
import { ModalAction } from '../../../state/actions/ui/ui'

type Action = {
  label: string,
  onClick?: () => void,
  dataAnalyticsAction?: analyticsAction,
  dataAnalyticsCategory?: Category,
  dataAnalyticsLabel?: string,
}

type Props = {
  content: React.ReactNode,
  isOpen: boolean,
  onClose: () => void,
  primaryAction?: ModalAction,
  secondaryAction?: Action,
  size?: ModalSizes,
  title: string,
}

const Modal = ({ title, content, isOpen, size, onClose, primaryAction, secondaryAction }: Props) => (
  <ModalAtom isOpen={isOpen} handleClose={onClose} size={size || ModalSizes.medium}>
    <Styles>
      <header className="header">
        <h2 data-testid="modal-heading">{title}</h2>
        <h3>{content}</h3>
      </header>
      <footer>
        {secondaryAction && <Button
          size={Button.Sizes.large}
          onClick={secondaryAction.onClick}
          variant={Button.Variants.secondary}
          data-testid="modal-secondary-action"
          dataAnalyticsAction={secondaryAction.dataAnalyticsAction}
          dataAnalyticsCategory={secondaryAction.dataAnalyticsCategory}
          dataAnalyticsLabel={secondaryAction.dataAnalyticsLabel}
        >
          {secondaryAction.label}
        </Button>}
        {primaryAction && <Button
          size={Button.Sizes.large}
          onClick={primaryAction.onClick}
          data-testid="modal-primary-action"
          dataAnalyticsAction={primaryAction.dataAnalyticsAction}
          dataAnalyticsCategory={primaryAction.dataAnalyticsCategory}
          dataAnalyticsLabel={primaryAction.dataAnalyticsLabel}
          svgHeight={primaryAction.iconHeight || null}
        >
          {primaryAction?.icon || null}
          {primaryAction.label}
        </Button>}
      </footer>
    </Styles>
  </ModalAtom>
)

export default Modal
